<template>
  <div class="app-container">
    <router-view />
    <!-- <TabBar> </TabBar> -->
  </div>
</template>

<script>
// import TabBar from '@/components/TabBar'
export default {
  data() {
    return {
      active: 0
    }
  }
}
</script>
<style lang="scss" scoped>
.app-container {
  padding-bottom: 10px;
}
</style>
